import React from "react";
import { useLocation } from "react-router-dom";
import ThreeWheeler from "../../../assets/three_wheeler.webp";
import TwoWheeler from "../../../assets/two_wheeler.webp";
import FourWheeler from "../../../assets/four_wheeler.webp";
import MiniTruck from "../../../assets/mini_truck.webp";

import { VEHICLE_IMAGES } from "../../../Utils/Vehicleimg";
import qr from "../../../assets/Qr.png";
import bgImg from "../../../assets/Grid.png";

const { car, truck, auto, bike } = VEHICLE_IMAGES;
const FALLBACK_VEHICLE_IMAGES = {
  "Two Wheeler": TwoWheeler,
  "Three Wheeler": ThreeWheeler,
  "Four Wheeler": FourWheeler,
  "Mini Truck": MiniTruck,
};

const vehicleData = {
  "Two Wheeler": {
    name: "Two Wheeler",
    image: bike,
  },
  "Three Wheeler": {
    name: "Three Wheeler",
    image: auto,
  },
  "Four Wheeler": {
    name: "Four Wheeler",
    image: car,
  },
  "Mini Truck": {
    name: "Mini Truck",
    image: truck,
  },
};

const DownloadApp = () => {
  const location = useLocation();

  const normalizeVehicleName = (vehicle = "") => {
    const value = String(vehicle).trim().toLowerCase();

    if (value.includes("two") || value.includes("2")) {
      return "Two Wheeler";
    }

    if (value.includes("three") || value.includes("3")) {
      return "Three Wheeler";
    }

    if (
      value.includes("four") ||
      value.includes("4") ||
      value.includes("eeco") ||
      value.includes("car")
    ) {
      return "Four Wheeler";
    }

    if (
      value.includes("mini") ||
      value.includes("truck") ||
      value.includes("pickup")
    ) {
      return "Mini Truck";
    }

    return vehicle;
  };

  const selectedVehicle = normalizeVehicleName(
    location.state?.vehicle || sessionStorage.getItem("selectedVehicle") || "",
  );

  const remainingVehicles = Object.entries(vehicleData).filter(
    ([vehicleName]) => vehicleName !== selectedVehicle,
  );
  return (
    <>
      <section
        className="w-full px-4 py-10 sm:py-12 lg:py-16"
        style={{
          backgroundImage: `url(${bgImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="mx-auto flex max-w-3xl flex-col items-center gap-8 rounded-3xl bg-[#f3dfcc] px-6 py-8 text-center shadow-sm sm:px-8 md:flex-row md:items-center md:justify-between md:text-left">
          {/* LEFT CONTENT */}
          <div className="max-w-[420px]">
            <h2 className="text-xl font-bold leading-tight text-[#2b2b2b] sm:text-[24px] lg:text-3xl">
              Fast, Simple Deliveries
              <br />
              with Packky
            </h2>

            <p className="mt-4 text-base leading-relaxed text-[#444] sm:text-lg">
              Use the Packky app to book and manage your deliveries with ease.
            </p>
          </div>

          {/* RIGHT QR */}
          <div className="flex flex-col items-center">
            <div className="rounded-lg bg-white p-2 shadow-sm">
              <img
                src={qr}
                alt="QR Code"
                className="h-[120px] w-[120px] object-contain sm:h-[140px] sm:w-[140px] lg:h-[150px] lg:w-[150px]"
              />
            </div>

            <p className="mt-4 text-xs font-semibold uppercase tracking-wide text-[#2b2b2b] sm:text-sm">
              Scan the QR Code
            </p>
          </div>
        </div>
      </section>
      <section
        className="w-full bg-white px-4 pb-10 sm:pb-14"
        style={{
          backgroundImage: `url(${bgImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="mx-auto max-w-5xl text-center">
          <span className="mb-4 inline-flex rounded-full bg-blue-50 px-4 py-2 text-[11px] font-semibold uppercase tracking-wide text-blue-700 sm:px-5 sm:text-xs">
            More Options
          </span>

          <h2 className="text-xl font-extrabold leading-tight text-[#07142f] sm:text-[24px] md:text-[30px]">
            Other Services to Choose From
          </h2>

          <p className="mx-auto mt-4 max-w-[620px] text-sm leading-6 text-slate-500">
            You selected{" "}
            <span className="font-bold text-blue-700">
              {selectedVehicle || "a vehicle"}
            </span>
            . Here are the other available services.
          </p>

          <div className="mx-auto mt-8 grid max-w-4xl grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {remainingVehicles.map(([vehicleName, data]) => (
              <div
                key={vehicleName}
                className="flex min-h-[180px] flex-col items-center justify-center rounded-[22px] bg-[#eef4ff] px-4 py-5 shadow-sm transition hover:-translate-y-1 hover:shadow-md"
              >
                <div className="mb-4 flex h-[48px] w-[64px] items-center justify-center rounded-2xl bg-white shadow-sm">
                  <img
                    src={data.image || FALLBACK_VEHICLE_IMAGES[vehicleName]}
                    alt={data.name}
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src =
                        FALLBACK_VEHICLE_IMAGES[vehicleName];
                    }}
                    className="h-[38px] w-[48px] object-contain"
                  />
                </div>

                <h3 className="mb-6 text-center text-[14px] font-extrabold text-[#07142f]">
                  {data.name}
                </h3>

                <button
                  type="button"
                  className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-600 text-sm font-bold text-white transition hover:bg-blue-700"
                >
                  →
                </button>
              </div>
            ))}
          </div>

          {remainingVehicles.length === 0 && (
            <div className="mx-auto mt-8 max-w-md rounded-2xl bg-[#eef4ff] px-6 py-5 text-center text-sm font-semibold text-slate-500">
              No other vehicles available.
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default DownloadApp;
